import {liveFlightEditorConfiguration} from 'components/flighteditor/live/configuration';
import {
    createFlightEditorWrapper
} from 'components/flighteditor/unified/configuration';
import {UnifiedFlightEditor} from 'components/flighteditor/unified/UnifiedFlightEditor';
import WithOrgData, {WithOrgDataProps} from 'components/WithOrgData';
import React from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';

export interface LiveFlightEditorProps extends WithOrgDataProps {
    flightId: string;
    style?: React.CSSProperties;
    onBack?: (event: React.MouseEvent<HTMLDivElement>) => void;
    onIDChange?(newID: string, previousID?: string): void;
}

const LiveFlightEditorWrapper = createFlightEditorWrapper<RouteComponentProps>(
    UnifiedFlightEditor,
    () => liveFlightEditorConfiguration
);

const LiveFlightEditor = withRouter(WithOrgData(LiveFlightEditorWrapper));
LiveFlightEditor.displayName = 'LiveFlightEditor';

export default LiveFlightEditor;
